export function Journal() {
  return <div className="text-xl my-3">(No Journal Available)</div>
}